import React, { memo } from 'react';

// Pill-style category filter. Single-select with an "All" chip.
function CategoryFilter({ categories, selected, onSelect }) {
  if (!categories || categories.length === 0) return null;

  return (
    <div className="category-filter" role="tablist" aria-label="Filter by category">
      <button
        type="button"
        className={`category-pill ${selected === 'All' ? 'active' : ''}`}
        onClick={() => onSelect('All')}
      >
        All
      </button>
      {categories.map(cat => (
        <button
          key={cat}
          type="button"
          className={`category-pill ${selected === cat ? 'active' : ''}`}
          onClick={() => onSelect(cat)}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}

// Memoized: re-renders only when the category list or selection changes, not on every
// App re-render (e.g. search keystrokes). onSelect is a stable useState setter.
export default memo(CategoryFilter);
